import React from 'react';

import SkipNextIcon from '@mui/icons-material/SkipNext';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';
import { Song } from 'src/@types/api-types';

import ControlBarValueLabel from 'components/b2c/ControlBarValueLabel';

import {
  CastingControlBarContainer,
  SongTitle,
  SongArtist,
  SongInfo,
  Slider,
} from './CastingControlBarContent.style';

interface CastingControlBarContentProps {
  handlePlayPauseClick: () => void;
  handlePlayNextSongClick: () => void;
  handleTimeSliderChange: (value: number | number[]) => void;
  handleTimeSliderChangeCommitted: () => void;
  songTitle?: string;
  songArtistName?: string;
  PlayPauseIcon: OverridableComponent<SvgIconTypeMap<object, 'svg'>>;
  nextSong: Song | null;
  timeSliderValue: number;
  timeSliderMax: number;
}

const CastingControlBarContent: React.FC<CastingControlBarContentProps> = ({
  handlePlayPauseClick,
  handlePlayNextSongClick,
  handleTimeSliderChange,
  handleTimeSliderChangeCommitted,
  songTitle,
  songArtistName,
  PlayPauseIcon,
  nextSong,
  timeSliderValue,
  timeSliderMax,
}) => (
  <CastingControlBarContainer>
    <SongInfo>
      <SongTitle title={songTitle}>{songTitle}</SongTitle>
      <SongArtist title={songArtistName}>{songArtistName}</SongArtist>
    </SongInfo>
    <Slider
      max={timeSliderMax}
      value={timeSliderValue}
      components={{
        ValueLabel: ControlBarValueLabel,
      }}
      valueLabelDisplay='auto'
      onChange={(_, value) => handleTimeSliderChange(value)}
      onChangeCommitted={handleTimeSliderChangeCommitted}
    />
    <PlayPauseIcon onClick={handlePlayPauseClick} fontSize='large' />
    {nextSong?.id && <SkipNextIcon onClick={handlePlayNextSongClick} fontSize='large' />}
  </CastingControlBarContainer>
);

export default CastingControlBarContent;
